module.exports = "https://and-static.ghzs.com/web/bbs-desktop/static/img/icon-点赞-默认.72553.png";